<ng-container *transloco="let t; prefix: 'notificationBell'">
  @if (content.redirectUrl) {
    <a
      type="button"
      [href]="content.redirectUrl"
      [class]="'notification ' + containerClass"
      [class.new]="notification.userNotificationStatus === 'New'"
    >
      <ng-container *ngTemplateOutlet="notificationContent; context: { content, notification }" />
    </a>
  } @else {
    <button
      type="button"
      [class]="'notification ' + containerClass"
      [class.new]="notification.userNotificationStatus === 'New'"
      (click)="onClick()"
    >
      <ng-container *ngTemplateOutlet="notificationContent; context: { content, notification }" />
    </button>
  }

  <ng-template #notificationContent let-content="content" let-notification="notification">
    <div class="content">
      <p>{{ t(content.titleLanguageKey, content.languageMergeData) }}</p>
      <p>
        <span class="time">{{ notification.notificationTime | timeToNow }} {{ notification.notificationTime ? ' ago' : '' }}</span>
        <span>&bull;</span>
        <button type="button" mat-button color="primary">{{ t(content.ctaLanguageKey, content.languageMergeData) }}</button>
      </p>
    </div>

    <div class="status">
      @if (showStatusIcon && notification.userNotificationStatus === 'New') {
        &bull;
      }
    </div>
  </ng-template>
</ng-container>
